import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useTranslation } from "react-i18next";
// import car_summer from "../assets/images/car-summer.png"
// import yellow_line from "../assets/images/yellow-line.png"

const PrivacyPolicy = () => {
  const { t, i18n } = useTranslation();
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  // useEffect(() => {
  //   const currentLang = i18n.language;
  //   const direction = currentLang === "ar" ? "rtl" : "ltr";
  //   document.documentElement.setAttribute("dir", direction);
  //   document.documentElement.setAttribute("lang", currentLang);
  // }, [i18n.language]);

  return (
    <>
      <div className="privacy-bg from-top">
        <Header />
      </div>

      <div className="container mt-5">
        <div className="row">
          <div className="col-md-1"></div>
          <div className="col-md-7 d-flex flex-column justify-content-center">
            <div className="position-relative">
              <h2 className="fw-bold">Contact Gear</h2>
              <img 
              // src={yellow_line}
               className="yellow_line" />
            </div>

            <p>Contact Global Arabian Trading by phone or email</p>
            <div>
              <p><strong>Contact Details:</strong></p>
              <p>
                <strong>UAE:</strong> <a href="tel:+971542210088">+971 54 22 100 88</a>
              </p>
              <p>
                <strong>Denmark:</strong> <a href="tel:+4527599957">+45 27599957</a>
              </p>
              <p>
                <a href="mailto:Customerservice@globalarabiantrading.com">Customerservice@globalarabiantrading.com</a>
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div style={{ width: "300px" }}>
              <img
              //  src={car_summer}
                className="w-100" />
            </div>
          </div>

          <div className="d-flex justify-content-center mt-5">
            <div style={{ width: "100%", maxWidth: "500px" }}>
              <h5 className="fw-bold mb-4">
                Get instant help from our experienced support team
              </h5>
              <form>
                <div className="mb-3">
                  <label className="form-label text-muted">
                    What is your name?
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder=""
                    style={{ backgroundColor: "#f5f5f5", border: "none" }}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label text-muted">
                    What is your contact number?
                  </label>
                  <input
                    type="tel"
                    className="form-control"
                    placeholder=""
                    style={{ backgroundColor: "#f5f5f5", border: "none" }}
                  />
                </div>

                <div className="mb-4">
                  <label className="form-label text-muted">
                    Tell us more about your issue?
                  </label>
                  <textarea
                    className="form-control"
                    rows="4"
                    style={{ backgroundColor: "#f5f5f5", border: "none" }}
                  ></textarea>
                </div>

                <div className="text-center">
                  <button
                    type="submit"
                    className="btn fw-bold"
                    style={{
                      backgroundColor: "#FEF233",
                      color: "black",
                      borderRadius: "10px",
                      width: "120px",
                    }}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
